(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const giftSubmitSelector = [
  '.discounty-bxgy-desktop-widget button.discounty-bxgy-desktop-widget__button--primary',
  '.discounty-bxgy-mobile-widget button.discounty-bxgy-mobile-widget__button--primary',
].join(', ');
let pendingGiftSubmit = null;

function finishGiftSubmit(action) {
  if (pendingGiftSubmit !== action) return;
  action.restoreFetch();
  action.closeObserver?.disconnect();
  if (action.button.getAttribute('aria-busy') === 'true') {
    if (action.previousBusy === null) action.button.removeAttribute('aria-busy');
    else action.button.setAttribute('aria-busy', action.previousBusy);
  }
  pendingGiftSubmit = null;
}

document.addEventListener('click', (event) => {
  const button = event.target?.closest?.(giftSubmitSelector);
  if (!button || button.disabled) return;
  if (pendingGiftSubmit) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  const action = {
    button,
    widget: button.closest('.discounty-bxgy-desktop-widget, .discounty-bxgy-mobile-widget'),
    previousBusy: button.getAttribute('aria-busy'),
    captured: false,
  };
  const previousFetch = window.fetch;
  let observing = true;
  action.restoreFetch = () => {
    observing = false;
    if (window.fetch === observeGiftFetch) window.fetch = previousFetch;
  };
  function observeGiftFetch(...args) {
    const [input, options] = args;
    let matches = false;
    if (observing && typeof input === 'string' && options?.method === 'POST') {
      try {
        const url = new URL(input, window.location.href);
        matches = url.origin === window.location.origin && url.pathname === '/cart/add.js'
          && new Headers(options.headers).get('X-Discounty-Trigger') === '1';
      } catch (_) { /* Let the original fetch handle invalid inputs. */ }
    }
    if (!matches) return Reflect.apply(previousFetch, this, args);

    // Observe only the native gift request; return its original promise unchanged.
    action.captured = true;
    action.restoreFetch();
    let request;
    try {
      request = Reflect.apply(previousFetch, this, args);
    } catch (error) {
      finishGiftSubmit(action);
      throw error;
    }
    Promise.resolve(request).then((response) => {
      if (!response.ok) finishGiftSubmit(action);
      else response.clone().json().catch(() => finishGiftSubmit(action));
    }, () => finishGiftSubmit(action)).catch(() => finishGiftSubmit(action));
    return request;
  }

  pendingGiftSubmit = action;
  button.setAttribute('aria-busy', 'true');
  window.fetch = observeGiftFetch;
  // Trusted clicks can run microtasks between capture and the native target handler.
  // Keep this observer through the event task; matching fetch still restores it immediately.
  setTimeout(() => {
    action.restoreFetch();
    if (!action.captured) finishGiftSubmit(action);
  }, 0);
}, true);

document.addEventListener('discounty:cart:updated', (event) => {
  if (event.detail?.source !== 'discounty' || event.detail?.trigger !== 'popup') return;
  const action = pendingGiftSubmit;
  if (!action?.captured || action.closeObserver) return;

  const releaseWhenClosed = () => {
    const widget = action.widget;
    const closed = !widget.isConnected || widget.style.display === 'none'
      || (widget.classList.contains('discounty-bxgy-mobile-widget')
        && !widget.classList.contains('discounty-bxgy-mobile-widget--is-open'));
    if (closed) finishGiftSubmit(action);
  };
  // Discounty announces success before closing its popup; keep blocking until it closes.
  action.closeObserver = new MutationObserver(releaseWhenClosed);
  action.closeObserver.observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'],
  });
  queueMicrotask(releaseWhenClosed);
});

document.addEventListener('discounty:cart:updated', (event) => {
  if (event.detail?.source !== 'discounty' || event.detail?.trigger !== 'popup') return;

  const drawer = document.querySelector('m-cart-drawer');
  if (typeof drawer?.onCartDrawerUpdate === 'function') {
    drawer.onCartDrawerUpdate();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamora-cart-removal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('FlamoraCartRemoval');
    if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const cancel = dialog.querySelector('[data-cart-removal-cancel]');
    const confirm = dialog.querySelector('[data-cart-removal-confirm]');
    const productName = dialog.querySelector('.flamora-cart-removal__product');
    let pending = null;
    let quantityObserver;
    let focusObserver;
    let focusTimeout;

    function findRow(state) {
      return state?.cart.isConnected
        ? Array.from(state.cart.querySelectorAll('[data-cart-item]')).find(row => row.dataset.id === state.key)
        : null;
    }

    function stopFocusWatch() {
      focusObserver?.disconnect();
      clearTimeout(focusTimeout);
    }

    document.addEventListener('click', event => {
      const button = event.target instanceof Element
        ? event.target.closest('m-quantity-input button[name="minus"]')
        : null;
      if (!button || button.disabled) return;
      const cart = button.closest('m-cart-template, m-cart-drawer-items');
      const input = button.closest('m-quantity-input').querySelector('input[name="updates[]"]');
      const row = button.closest('[data-cart-item]');
      if (!cart || !row?.dataset.id || !input || input.disabled || Number(input.value) !== 1) return;
      if (typeof cart.updateQuantity !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (dialog.open) return;
      stopFocusWatch();
      pending = { cart, key: row.dataset.id, button };
      const updateConfirmation = () => {
        const currentRow = findRow(pending);
        const currentInputs = currentRow ? Array.from(currentRow.querySelectorAll('m-quantity-input input[name="updates[]"]')) : [];
        confirm.disabled = !currentInputs.length || currentInputs.some(field => Number(field.value) !== 1 || Number(field.getAttribute('value')) !== 1);
        dialog.setAttribute('aria-busy', String(confirm.disabled));
      };
      updateConfirmation();
      quantityObserver = new MutationObserver(updateConfirmation);
      quantityObserver.observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
      productName.textContent = row.querySelector('.m-cart--item-name')?.textContent.trim() || '';
      dialog.showModal();
      cancel.focus({ preventScroll: true });
    }, true);

    cancel.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      quantityObserver?.disconnect();
      dialog.removeAttribute('aria-busy');
      const state = pending;
      pending = null;
      const currentButton = state?.button.isConnected && state.button.getClientRects().length
        ? state.button
        : Array.from(findRow(state)?.querySelectorAll('m-quantity-input button[name="minus"]') || []).find(button => button.getClientRects().length);
      currentButton?.focus({ preventScroll: true });
    });
    confirm.addEventListener('click', () => {
      const state = pending;
      const row = findRow(state);
      const inputs = row ? Array.from(row.querySelectorAll('m-quantity-input input[name="updates[]"]')) : [];
      const remove = row?.querySelector('m-cart-remove-button');
      if (!remove || !inputs.length || inputs.some(input => Number(input.value) !== 1 || Number(input.getAttribute('value')) !== 1)) {
        dialog.close();
        return;
      }
      pending = null;
      dialog.close();
      stopFocusWatch();
      focusObserver = new MutationObserver(() => {
        if (findRow(state)) return;
        stopFocusWatch();
        if (dialog.open) return;
        const focusTarget = Array.from(state.cart.querySelectorAll('m-quantity-input button:not(:disabled), a[href]')).find(element => element.getClientRects().length)
          || state.cart.closest('m-cart-drawer')?.querySelector('.m-cart-drawer--close-icon')
          || document.querySelector('#MainContent h1');
        if (focusTarget?.matches('h1') && !focusTarget.hasAttribute('tabindex')) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
        }
        focusTarget?.focus({ preventScroll: true });
      });
      focusObserver.observe(state.cart, { childList: true, subtree: true });
      focusTimeout = setTimeout(stopFocusWatch, 10000);
      remove.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamora-product-detail-links"] && !Shopify.designMode) return;
  try {
    let flamoraDetailScrollTimer;
  function cancelFlamoraDetailScroll() { clearTimeout(flamoraDetailScrollTimer); }
  window.addEventListener('wheel', cancelFlamoraDetailScroll, { passive: true });
  window.addEventListener('touchstart', cancelFlamoraDetailScroll, { passive: true });
  window.addEventListener('keydown', cancelFlamoraDetailScroll);
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-flamora-detail-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target || !target.classList.contains('acc-initialized')) return;
    const items = Array.from(target.querySelectorAll('[data-flamora-detail-block]'));
    const index = items.findIndex(item => item.dataset.flamoraDetailBlock === link.dataset.flamoraDetailLink);
    if (index < 0) return;
    const item = items[index];
    const tab = target.querySelectorAll('.sf-tab-header')[index];
    const accordionButton = item.querySelector('.sf__accordion-button');
    const mobile = window.matchMedia('(max-width: 767px)').matches && accordionButton;
    cancelFlamoraDetailScroll();
    if (mobile) event.preventDefault();
    if (tab) tab.click();
    if (!item.classList.contains('open') && accordionButton) accordionButton.click();
    if (mobile) {
      if (window.location.hash !== link.hash) window.history.pushState(window.history.state, '', link.hash);
      flamoraDetailScrollTimer = setTimeout(function () {
        const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 120;
        if (accordionButton.tabIndex < 0 && !accordionButton.hasAttribute('tabindex')) accordionButton.setAttribute('tabindex', '-1');
        accordionButton.focus({ preventScroll: true });
        window.scrollTo({ top: Math.max(0, window.scrollY + accordionButton.getBoundingClientRect().top - offset), behavior: 'instant' });
      }, 350);
    } else {
      requestAnimationFrame(function () {
        target.focus({ preventScroll: true });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
